"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _imageItem = _interopRequireDefault(require("./imageItem.js"));

var _videoItem = _interopRequireDefault(require("./videos/videoItem"));

var _textItem = _interopRequireDefault(require("./textItem.js"));

var _videoItemPlaceholder = _interopRequireDefault(require("./videos/videoItemPlaceholder.js"));

var _itemHover = _interopRequireDefault(require("./itemHover.js"));

var _texts = _interopRequireDefault(require("./texts/texts.js"));

var _social = _interopRequireDefault(require("./social/social.js"));

var _share = _interopRequireDefault(require("./share/share.js"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("../../utils/index.js"));

var _windowWrapper = _interopRequireDefault(require("../../utils/window/windowWrapper"));

var _cssScrollHelper = require("../helpers/cssScrollHelper");

var _versionsHelper = require("../helpers/versionsHelper");

var _galleryComponent = require("../galleryComponent");

var _viewModeWrapper = require("../../utils/window/viewModeWrapper");

var _events = _interopRequireDefault(require("../../constants/events"));

var _placements = _interopRequireDefault(require("../../constants/placements"));

var _overlayAnimations = _interopRequireDefault(require("../../constants/overlayAnimations"));

var _imageHoverAnimations = _interopRequireDefault(require("../../constants/imageHoverAnimations"));

var _itemViewStyleProvider = require("./itemViewStyleProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ItemView =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(ItemView, _GalleryComponent);

  function ItemView(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "shouldUseDirectLink", function () {
      var directLink = _this.props.directLink;

      var _ref = directLink || {},
          url = _ref.url,
          target = _ref.target;

      var useDirectLink = !!(url && target && _this.props.styleParams.itemClick === 'link');
      var shouldUseDirectLinkMobileSecondClick = _this.shouldShowHoverOnMobile() && _this.isClickOnCurrentHoveredItem() && useDirectLink;

      if (shouldUseDirectLinkMobileSecondClick) {
        _this.props.actions.eventsListener(_events["default"].HOVER_SET, -1);

        return true;
      }

      if (useDirectLink && !_this.shouldShowHoverOnMobile()) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isClickOnCurrentHoveredItem", function () {
      return _this.props.currentHover === _this.props.idx;
    });

    _this.props.actions.eventsListener(_events["default"].ITEM_CREATED, _this.props);

    _this.init();

    _this.state = {
      failed: false,
      loaded: false,
      displayed: false,
      retries: 0,
      showShare: false
    };
    _this.activeElement = '';
    return _this;
  } //-------------------------------------------| INIT |--------------------------------------------//


  var _proto = ItemView.prototype;

  _proto.init = function init() {
    this.onItemClick = this.onItemClick.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.toggleFullscreenIfNeeded = this.toggleFullscreenIfNeeded.bind(this);
    this.handleItemMouseDown = this.handleItemMouseDown.bind(this);
    this.handleItemMouseUp = this.handleItemMouseUp.bind(this);
    this.setItemLoaded = this.setItemLoaded.bind(this);
    this.setItemError = this.setItemError.bind(this);
    this.isVerticalContainer = this.isVerticalContainer.bind(this);
    this.isHighlight = this.isHighlight.bind(this);
    this.toggleShare = this.toggleShare.bind(this);
    this.getShare = this.getShare.bind(this);
    this.getItemHover = this.getItemHover.bind(this);
    this.getImageItem = this.getImageItem.bind(this);
    this.getVideoItem = this.getVideoItem.bind(this);
    this.getVideoItemPlaceholder = this.getVideoItemPlaceholder.bind(this);
    this.getTextItem = this.getTextItem.bind(this);
    this.getItemInner = this.getItemInner.bind(this);
    this.getItemContainerStyles = this.getItemContainerStyles.bind(this);
    this.getItemWrapperStyles = this.getItemWrapperStyles.bind(this);
    this.getItemAriaLabel = this.getItemAriaLabel.bind(this);
    this.getItemContainerClass = this.getItemContainerClass.bind(this);
    this.getItemWrapperClass = this.getItemWrapperClass.bind(this);
    this.getItemContainerTabIndex = this.getItemContainerTabIndex.bind(this);
    this.isIconTag = this.isIconTag.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.changeActiveElementIfNeeded = this.changeActiveElementIfNeeded.bind(this);
  } //----------------------------------------| ACTIONS |-------------------------------------------//
  ;

  _proto.setItemError = function setItemError() {
    this.setState({
      retries: this.state.retries + 1,
      failed: this.state.retries >= 3
    });
  };

  _proto.setItemLoaded = function setItemLoaded() {
    var _this2 = this;

    this.props.actions.eventsListener(_events["default"].ITEM_LOADED, this.props);
    this.setState({
      failed: false,
      loaded: true
    });
    setTimeout(function () {
      _this2.setState({
        displayed: true
      });
    }, 1500);
  };

  _proto.isIconTag = function isIconTag(tagName) {
    return ['button', 'i', 'a'].indexOf(tagName.toLowerCase()) >= 0;
  };

  _proto.toggleShare = function toggleShare(event, forceVal) {
    event.stopPropagation();
    event.preventDefault();

    if (event.type === 'mouseout' && (this.isIconTag(event.target.tagName) || event.relatedTarget && this.isIconTag(event.relatedTarget.tagName))) {
      //mouseout event should not be fired if hovering over icons (tag name === I)
      return;
    }

    this.setState({
      showShare: typeof forceVal === 'undefined' ? !this.state.showShare : !!forceVal
    });
  };

  _proto.onMouseOver = function onMouseOver() {
    this.props.actions.eventsListener(_events["default"].HOVER_SET, this.props.idx);
    this.onMouseOverEvent.itemIdx = this.props.idx; //VIDEOREWORK why do we need this?

    _windowWrapper["default"].dispatchEvent(this.onMouseOverEvent);
  };

  _proto.onKeyPress = function onKeyPress(e) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();
        e.stopPropagation();
        this.onItemClick(e); //pressing enter or space always behaves as click on main image, even if the click is on a thumbnail

        return false;

      default:
        return true;
    }
  };

  _proto.handleGalleryItemClick = function handleGalleryItemClick() {
    _index["default"].isFunction(_index["default"].get(_windowWrapper["default"], 'galleryWixCodeApi.onItemClicked')) && _windowWrapper["default"].galleryWixCodeApi.onItemClicked(this.props); //TODO remove after OOI is fully integrated

    this.props.actions.eventsListener(_events["default"].ITEM_ACTION_TRIGGERED, this.props);
  };

  _proto.onItemClick = function onItemClick(e) {
    this.props.actions.eventsListener(_events["default"].ITEM_CLICKED, this.props);

    if (this.shouldUseDirectLink()) {
      return function () {};
    }

    e.preventDefault();

    if (this.shouldShowHoverOnMobile()) {
      this.handleHoverClickOnMobile();
    } else {
      this.handleGalleryItemClick();
    }
  };

  _proto.handleHoverClickOnMobile = function handleHoverClickOnMobile() {
    if (this.isClickOnCurrentHoveredItem()) {
      this.handleGalleryItemClick();
      this.props.actions.eventsListener(_events["default"].HOVER_SET, -1);
    } else {
      this.props.actions.eventsListener(_events["default"].HOVER_SET, this.props.idx);
    }
  };

  _proto.toggleFullscreenIfNeeded = function toggleFullscreenIfNeeded(e) {
    var targetClass = _index["default"].get(e, 'target.className');

    if (typeof targetClass === 'object') {
      targetClass = Object.values(targetClass);
    }

    if (_index["default"].isFunction(targetClass.indexOf) && targetClass.indexOf('block-fullscreen') >= 0) {
      console.warn('Blocked fullscreen!', e);
      return;
    } else if (this.props.styleParams.fullscreen) {
      this.props.actions.eventsListener(_events["default"].ITEM_ACTION_TRIGGERED, this.props);
    }
  };

  _proto.handleItemMouseDown = function handleItemMouseDown() {
    //check for long press
    // if (utils.isMobile()) {
    //   clearTimeout(this.longPressTimer);
    //   this.longPressTimer = setTimeout(() => {
    //     e.preventDefault(); //prevent default only after a long press (so that scroll will not break)
    //     //do something
    //   }, 500);
    // }
    return true; //make sure the default event behaviour continues
  };

  _proto.handleItemMouseUp = function handleItemMouseUp() {
    if (_index["default"].isMobile() && this.longPressTimer) {
      clearTimeout(this.longPressTimer);
    }

    return true; //make sure the default event behaviour continues
  } //-----------------------------------------| UTILS |--------------------------------------------//
  ;

  _proto.isSmallItem = function isSmallItem() {
    if (this.props.styleParams.isSlideshow) {
      return false;
    }

    var isSmallItem;
    var maxWidth = 90;
    var maxHeight = 90;

    if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fit') {
      if (this.props.style.orientation === 'landscape') {
        //wide image
        isSmallItem = this.props.style.width / this.props.style.ratio <= maxHeight;
      } else {
        //tall image
        isSmallItem = this.props.style.height * this.props.style.ratio <= maxWidth;
      }
    } else {
      isSmallItem = this.props.style.width <= maxWidth || this.props.style.height <= maxHeight;
    }

    return isSmallItem;
  };

  _proto.isNarrow = function isNarrow() {
    return this.props.style.width < 200;
  };

  _proto.isShort = function isShort() {
    return this.props.style.height < 150;
  };

  _proto.isVerticalContainer = function isVerticalContainer() {
    return this.props.style.width < this.props.style.height + 1;
  };

  _proto.shouldShowHoverOnMobile = function shouldShowHoverOnMobile() {
    if (_index["default"].isMobile()) {
      var _this$props$stylePara = this.props.styleParams,
          allowDescription = _this$props$stylePara.allowDescription,
          allowTitle = _this$props$stylePara.allowTitle,
          titlePlacement = _this$props$stylePara.titlePlacement,
          itemClick = _this$props$stylePara.itemClick,
          isSlideshow = _this$props$stylePara.isSlideshow,
          alwaysShowHover = _this$props$stylePara.alwaysShowHover,
          previewHover = _this$props$stylePara.previewHover;
      var isNewMobileSettings = _versionsHelper.featureManager.supports.mobileSettings;

      if (isSlideshow) {
        return false;
      }

      if (itemClick === 'nothing' && this.props.type !== 'video') {
        return true;
      } else if ((allowTitle || allowDescription) && (titlePlacement === _placements["default"].SHOW_ON_HOVER || titlePlacement === _placements["default"].SHOW_NOT_ON_HOVER || titlePlacement === _placements["default"].SHOW_ALWAYS) && isNewMobileSettings) {
        return true;
      }

      if (alwaysShowHover) {
        return true;
      }

      if ((0, _viewModeWrapper.isEditMode)() && previewHover) {
        return true;
      }
    }

    return false;
  };

  _proto.isHighlight = function isHighlight() {
    return this.props.thumbnailHighlightId && this.props.thumbnailHighlightId === this.props.id;
  };

  _proto.shouldHover = function shouldHover() {
    var styleParams = this.props.styleParams;

    if (styleParams.isSlideshow) {
      return false;
    } else if (styleParams.alwaysShowHover === true) {
      return true;
    } else if ((0, _viewModeWrapper.isEditMode)() && styleParams.previewHover === true) {
      return true;
    } else if (styleParams.allowHover === false) {
      return false;
    } else if (_index["default"].isMobile()) {
      return this.shouldShowHoverOnMobile();
    } else {
      return true;
    }
  } //---------------------------------------| COMPONENTS |-----------------------------------------//
  ;

  _proto.getImageDimensions = function getImageDimensions() {
    //image dimensions are for images in grid fit - placing the image with positive margins to show it within the square
    if (_index["default"].isSSR()) {
      return {};
    }

    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        cubeRatio = _this$props.cubeRatio,
        style = _this$props.style;
    var imageIsWider = style.ratio >= cubeRatio;
    var imageMarginLeft = Math.round((style.height * style.ratio - style.width) / -2);
    var imageMarginTop = Math.round((style.width / style.ratio - style.height) / -2);
    return !(styleParams.cubeImages && styleParams.cubeType === 'fit') ? {
      //not grid fit
      width: style.width,
      height: style.height
    } : //grid fit images
    !imageIsWider ? {
      //portrait
      width: style.width - 2 * imageMarginLeft,
      height: style.height,
      marginLeft: imageMarginLeft
    } : {
      //landscape
      height: style.height - 2 * imageMarginTop,
      width: style.width,
      marginTop: imageMarginTop
    };
  };

  _proto.getItemTextsDetails = function getItemTextsDetails() {
    var props = _index["default"].pick(this.props, ['title', 'description', 'id', 'styleParams', 'style', 'container']);

    var isImage = this.props.type === 'image' || this.props.type === 'picture';
    var useCustomButton = this.props.styleParams.useCustomButton === true;
    var shouldShowButton = (isImage || !this.props.styleParams.isStoreGallery) && useCustomButton;
    return _react["default"].createElement(_texts["default"], _extends({}, props, {
      key: "item-texts-" + props.id,
      itemContainer: this.itemContainer,
      showShare: this.state.showShare,
      isSmallItem: this.isSmallItem(),
      isNarrow: this.isNarrow(),
      shouldShowButton: shouldShowButton,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    }));
  };

  _proto.getSocial = function getSocial() {
    var props = _index["default"].pick(this.props, ['html', 'hashtag', 'photoId', 'item', 'idx', 'currentIdx', 'id', 'styleParams', 'style', 'isDemo', 'type', 'createUrl', 'loveCount', 'isLoved']);

    return _react["default"].createElement(_social["default"], _extends({}, props, {
      showShare: this.state.showShare,
      isSmallItem: this.isSmallItem(),
      isNarrow: this.isNarrow(),
      isShort: this.isShort(),
      isVerticalContainer: this.isVerticalContainer(),
      key: "item-social-" + props.id,
      actions: {
        openItemShopInFullScreen: this.openItemShopInFullScreen,
        toggleShare: this.toggleShare,
        getShare: this.getShare,
        eventsListener: this.props.actions.eventsListener
      }
    }));
  };

  _proto.getShare = function getShare() {
    var props = _index["default"].pick(this.props, ['styleParams', 'id', 'type', 'style', 'currentIdx', 'idx', 'actions']);

    return _react["default"].createElement(_share["default"], _extends({}, props, {
      allProps: this.props,
      key: "item-share-" + props.id,
      showShare: this.state.showShare,
      isVerticalContainer: this.isVerticalContainer(),
      actions: {
        toggleShare: this.toggleShare,
        eventsListener: this.props.actions.eventsListener
      }
    }));
  };

  _proto.getItemHover = function getItemHover(children, imageDimensions) {
    // const props = utils.pick(this.props, ['styleParams', 'type', 'idx', 'type']);
    var _this$props2 = this.props,
        customHoverRenderer = _this$props2.customHoverRenderer,
        props = _objectWithoutPropertiesLoose(_this$props2, ["customHoverRenderer"]);

    return _react["default"].createElement(_itemHover["default"], _extends({}, props, {
      forceShowHover: this.simulateOverlayHover(),
      shouldHover: this.shouldHover(),
      imageDimensions: imageDimensions,
      key: "hover",
      actions: {
        handleItemMouseDown: this.handleItemMouseDown,
        handleItemMouseUp: this.handleItemMouseUp
      },
      render: customHoverRenderer
    }), children);
  };

  _proto.getImageItem = function getImageItem(imageDimensions) {
    var props = _index["default"].pick(this.props, ['alt', 'title', 'description', 'id', 'idx', 'styleParams', 'createUrl', 'settings']);

    return _react["default"].createElement(_imageItem["default"], _extends({}, props, {
      key: "imageItem",
      loaded: this.state.loaded,
      displayed: this.state.displayed,
      imageDimensions: imageDimensions,
      isThumbnail: !!this.props.thumbnailHighlightId,
      actions: {
        handleItemMouseDown: this.handleItemMouseDown,
        handleItemMouseUp: this.handleItemMouseUp,
        setItemLoaded: this.setItemLoaded,
        setItemError: this.setItemError
      }
    }));
  };

  _proto.getVideoItem = function getVideoItem(imageDimensions, itemHover) {
    return _react["default"].createElement(_videoItem["default"], _extends({}, this.props, {
      playing: this.props.idx === this.props.playingVideoIdx,
      key: 'video' + this.props.idx,
      hover: itemHover,
      imageDimensions: imageDimensions,
      loadingStatus: {
        failed: this.state.failed,
        loaded: this.state.loaded
      },
      actions: _objectSpread({}, this.props.actions, {
        setItemLoaded: this.setItemLoaded,
        setItemError: this.setItemError,
        handleItemMouseDown: this.handleItemMouseDown,
        handleItemMouseUp: this.handleItemMouseUp
      })
    }));
  };

  _proto.getVideoItemPlaceholder = function getVideoItemPlaceholder(imageDimensions, itemHover) {
    var props = _index["default"].pick(this.props, ['alt', 'title', 'description', 'id', 'idx', 'styleParams', 'createUrl', 'settings']);

    return _react["default"].createElement(_videoItemPlaceholder["default"], _extends({}, props, {
      loadingStatus: {
        failed: this.state.failed,
        loaded: this.state.loaded
      },
      key: "videoPlaceholder",
      loaded: this.state.loaded,
      displayed: this.state.displayed,
      imageDimensions: imageDimensions,
      isThumbnail: !!this.props.thumbnailHighlightId,
      actions: {
        handleItemMouseDown: this.handleItemMouseDown,
        handleItemMouseUp: this.handleItemMouseUp,
        setItemLoaded: this.setItemLoaded,
        setItemError: this.setItemError
      },
      id: this.props.idx,
      hover: itemHover
    }));
  };

  _proto.getTextItem = function getTextItem(imageDimensions) {
    var props = _index["default"].pick(this.props, ['id', 'styleParams', 'style', 'html', 'cubeRatio']);

    return _react["default"].createElement(_textItem["default"], _extends({}, props, {
      key: "textItem",
      imageDimensions: imageDimensions,
      actions: {
        handleItemMouseDown: this.handleItemMouseDown,
        handleItemMouseUp: this.handleItemMouseUp,
        setItemLoaded: this.setItemLoaded
      }
    }));
  };

  _proto.getItemInner = function getItemInner() {
    var _this$props3 = this.props,
        styleParams = _this$props3.styleParams,
        type = _this$props3.type;
    var itemInner;
    var imageDimensions = this.getImageDimensions();
    var itemTexts = styleParams.titlePlacement === _placements["default"].SHOW_ON_HOVER || styleParams.titlePlacement === _placements["default"].SHOW_NOT_ON_HOVER || styleParams.titlePlacement === _placements["default"].SHOW_ALWAYS ? this.getItemTextsDetails() : null; //if titlePlacement (title & description) is BELOW or ABOVE, it is not part of the itemHover

    var social = this.getSocial();
    var share = this.getShare();
    var itemHover = this.getItemHover([itemTexts, social, share], imageDimensions);

    switch (type) {
      case 'dummy':
        itemInner = _react["default"].createElement("div", null);
        break;

      case 'video':
        if (this.props.idx === this.props.playingVideoIdx || this.props.idx === this.props.nextVideoIdx) {
          itemInner = this.getVideoItem(imageDimensions, itemHover);
        } else {
          itemInner = this.getVideoItemPlaceholder(imageDimensions, itemHover);
        }

        break;

      case 'text':
        itemInner = [this.getTextItem(imageDimensions), itemHover];
        break;

      case 'image':
      case 'picture':
      default:
        itemInner = [this.getImageItem(imageDimensions), itemHover];
    }

    if (styleParams.isSlideshow) {
      itemTexts = this.getItemTextsDetails();
      var style = {
        height: styleParams.slideshowInfoSize + "px",
        bottom: "-" + styleParams.slideshowInfoSize + "px"
      };
      itemInner = _react["default"].createElement("div", null, itemInner, this.props.currentIdx === this.props.idx ? _react["default"].createElement("div", {
        className: "gallery-item-info gallery-item-bottom-info",
        "data-hook": "gallery-item-info-buttons",
        style: style
      }, _react["default"].createElement("div", null, social, itemTexts)) : false);
    }

    return itemInner;
  };

  _proto.openItemShopInFullScreen = function openItemShopInFullScreen(e) {
    e.preventDefault();
    e.stopPropagation();
    this.toggleFullscreenIfNeeded(e);
  };

  _proto.getBottomInfoElementIfNeeded = function getBottomInfoElementIfNeeded() {
    var styleParams = this.props.styleParams;

    if (styleParams.titlePlacement === _placements["default"].SHOW_BELOW && (styleParams.allowTitle || styleParams.allowDescription || styleParams.useCustomButton)) {
      return this.getInfoElement('gallery-item-bottom-info');
    } else {
      return null;
    }
  };

  _proto.getTopInfoElementIfNeeded = function getTopInfoElementIfNeeded() {
    var styleParams = this.props.styleParams;

    if (styleParams.titlePlacement === _placements["default"].SHOW_ABOVE && (styleParams.allowTitle || styleParams.allowDescription || styleParams.useCustomButton)) {
      return this.getInfoElement('gallery-item-top-info');
    } else {
      return null;
    }
  };

  _proto.getInfoElement = function getInfoElement(elementName) {
    var _this3 = this;

    var styleParams = this.props.styleParams;
    var info = null; //TODO: move the creation of the functions that are passed to onMouseOver and onMouseOut outside

    var customInfoRenderer = this.props.customInfoRenderer;
    var itemTexts = customInfoRenderer ? customInfoRenderer(this.props) : this.getItemTextsDetails();

    if (itemTexts) {
      info = _react["default"].createElement("div", {
        style: (0, _itemViewStyleProvider.getOuterInfoStyle)(styleParams)
      }, _react["default"].createElement("div", {
        style: (0, _itemViewStyleProvider.getInnerInfoStyle)(styleParams),
        className: elementName,
        onMouseOver: function onMouseOver() {
          !_index["default"].isMobile() && _this3.props.actions.eventsListener(_events["default"].HOVER_SET, _this3.props.idx);
        },
        "aria-hidden": true,
        onMouseOut: function onMouseOut() {
          !_index["default"].isMobile() && _this3.props.actions.eventsListener(_events["default"].HOVER_SET, -1);
        }
      }, itemTexts));
    }

    return info;
  };

  _proto.simulateHover = function simulateHover() {
    return this.props.currentHover === this.props.idx || this.props.styleParams.alwaysShowHover === true || (0, _viewModeWrapper.isEditMode)() && this.props.styleParams.previewHover === true;
  };

  _proto.simulateOverlayHover = function simulateOverlayHover() {
    return this.simulateHover() || this.props.styleParams.titlePlacement === _placements["default"].SHOW_ALWAYS;
  };

  _proto.getItemContainerStyles = function getItemContainerStyles() {
    var _this$props4 = this.props,
        styleParams = _this$props4.styleParams,
        style = _this$props4.style,
        transform = _this$props4.transform,
        offset = _this$props4.offset;
    var containerStyleByStyleParams = (0, _itemViewStyleProvider.getContainerStyle)(styleParams);
    var itemStyles = {
      overflowY: styleParams.isSlideshow ? 'visible' : 'hidden',
      position: 'absolute',
      bottom: 'auto',
      margin: styleParams.oneRow ? styleParams.imageMargin + 'px' : 0
    };

    if (_index["default"].isSSR()) {
      return _objectSpread({}, itemStyles, {}, transform, {}, containerStyleByStyleParams); //in SSR, item styles arrive from css. htydrate phase should change these
    }

    ;
    var positionStyles = {
      top: offset.top,
      width: style.width,
      height: style.height + (styleParams.externalInfoHeight || 0)
    };
    var isRTL = true;
    var rtlStyles = {
      left: isRTL ? 'auto' : offset.left,
      right: !isRTL ? 'auto' : offset.left
    };

    var styles = _objectSpread({}, itemStyles, {}, transform, {}, containerStyleByStyleParams);

    return styles;
  };

  _proto.getItemWrapperStyles = function getItemWrapperStyles() {
    var _this$props5 = this.props,
        styleParams = _this$props5.styleParams,
        style = _this$props5.style,
        type = _this$props5.type;
    var height = style.height;
    var styles = {};

    if (type === 'text') {
      styles.backgroundColor = styleParams.cubeType !== 'fit' ? 'transparent' : 'inherit';
    } else {
      styles.backgroundColor = (styleParams.cubeType !== 'fit' ? style.bgColor : 'inherit') || 'transparent';
    }

    styles.height = height + 'px';
    styles.margin = -styleParams.itemBorderWidth + 'px';
    return _objectSpread({}, styles, {}, this.getImageDimensions());
  };

  _proto.getItemAriaLabel = function getItemAriaLabel() {
    var _this$props6 = this.props,
        type = _this$props6.type,
        alt = _this$props6.alt,
        styleParams = _this$props6.styleParams;
    var label;

    switch (type) {
      case 'dummy':
        label = '';
        break;

      case 'text':
        label = 'Text item';
        break;

      case 'video':
        label = alt || 'Untitled video';
        break;

      default:
        label = alt || 'Untitled image';
        break;
    }

    return label + (styleParams.isStoreGallery ? ', Buy Now' : '');
  };

  _proto.getItemContainerClass = function getItemContainerClass() {
    var styleParams = this.props.styleParams;
    var isNOTslideshow = !styleParams.isSlideshow;
    var overlayAnimation = styleParams.overlayAnimation;
    var imageHoverAnimation = styleParams.imageHoverAnimation;
    var className = (0, _classnames["default"])('gallery-item-container', 'visible', {
      highlight: this.isHighlight(),
      clickable: styleParams.itemClick !== 'nothing',
      'simulate-hover': this.simulateHover(),
      'hide-hover': !this.simulateHover() && _index["default"].isMobile(),
      'invert-hover': styleParams.titlePlacement === _placements["default"].SHOW_NOT_ON_HOVER,
      //overlay animations
      'hover-animation-fade-in': isNOTslideshow && overlayAnimation === _overlayAnimations["default"].FADE_IN,
      'hover-animation-expand': isNOTslideshow && overlayAnimation === _overlayAnimations["default"].EXPAND,
      'hover-animation-slide-up': isNOTslideshow && overlayAnimation === _overlayAnimations["default"].SLIDE_UP,
      'hover-animation-slide-right': isNOTslideshow && overlayAnimation === _overlayAnimations["default"].SLIDE_RIGHT,
      //image hover animations
      'zoom-in-on-hover': isNOTslideshow && imageHoverAnimation === _imageHoverAnimations["default"].ZOOM_IN,
      'blur-on-hover': isNOTslideshow && imageHoverAnimation === _imageHoverAnimations["default"].BLUR,
      'grayscale-on-hover': isNOTslideshow && imageHoverAnimation === _imageHoverAnimations["default"].GRAYSCALE,
      'shrink-on-hover': isNOTslideshow && imageHoverAnimation === _imageHoverAnimations["default"].SHRINK,
      'invert-on-hover': isNOTslideshow && imageHoverAnimation === _imageHoverAnimations["default"].INVERT,
      'color-in-on-hover': isNOTslideshow && imageHoverAnimation === _imageHoverAnimations["default"].COLOR_IN,
      'darkened-on-hover': isNOTslideshow && imageHoverAnimation === _imageHoverAnimations["default"].DARKENED,
      'pro-gallery-mobile-indicator': _index["default"].isMobile()
    });
    return className;
  };

  _proto.getItemWrapperClass = function getItemWrapperClass() {
    var _this$props7 = this.props,
        styleParams = _this$props7.styleParams,
        type = _this$props7.type;
    var classes = ['gallery-item-wrapper', 'visible'];

    if (styleParams.cubeImages) {
      classes.push('cube-type-' + styleParams.cubeType);
    }

    if (type === 'text') {
      classes.push('gallery-item-wrapper-text');
    }

    return classes.join(' ');
  };

  _proto.getItemContainerTabIndex = function getItemContainerTabIndex() {
    var tabIndex = this.isHighlight() ? _index["default"].getTabIndex('currentThumbnail') : this.props.currentIdx === this.props.idx ? _index["default"].getTabIndex('currentGalleryItem') : -1;
    return tabIndex;
  };

  _proto.changeActiveElementIfNeeded = function changeActiveElementIfNeeded(prevProps) {
    var _this4 = this;

    try {
      if (((0, _viewModeWrapper.isSiteMode)() || (0, _viewModeWrapper.isSEOMode)()) && !_index["default"].isMobile() && _windowWrapper["default"].document && _windowWrapper["default"].document.activeElement && _windowWrapper["default"].document.activeElement.className) {
        var activeElement = _windowWrapper["default"].document.activeElement; //check if focus is on 'gallery-item-container' in current gallery

        var isThisGalleryItemInFocus = function isThisGalleryItemInFocus() {
          return !!_windowWrapper["default"].document.querySelector("#pro-gallery-" + _this4.props.galleryDomId + " #" + String(activeElement.id));
        };

        var isGalleryItemInFocus = function isGalleryItemInFocus() {
          return String(activeElement.className).indexOf('gallery-item-container') >= 0;
        }; //check if focus is on 'load-more' in current gallery


        var isThisGalleryShowMoreInFocus = function isThisGalleryShowMoreInFocus() {
          return !!_windowWrapper["default"].document.querySelector("#pro-gallery-" + _this4.props.galleryDomId + " #" + String(activeElement.id));
        };

        var isShowMoreInFocus = function isShowMoreInFocus() {
          return String(activeElement.className).indexOf('show-more') >= 0;
        };

        if (isGalleryItemInFocus() && isThisGalleryItemInFocus() || isShowMoreInFocus() && isThisGalleryShowMoreInFocus()) {
          if (this.props.thumbnailHighlightId !== prevProps.thumbnailHighlightId && this.props.thumbnailHighlightId === this.props.id) {
            // if the highlighted thumbnail changed and it is the same as this itemview's
            this.itemContainer.focus();
          } else if (this.props.currentIdx !== prevProps.currentIdx && this.props.currentIdx === this.props.idx) {
            //check if currentIdx has changed to the current item
            this.itemContainer.focus();
          }
        }
      }
    } catch (e) {
      console.error('Could not set focus to active element', e);
    }
  } //-----------------------------------------| REACT |--------------------------------------------//
  ;

  _proto.componentDidMount = function componentDidMount() {
    this.onMouseOverEvent = _windowWrapper["default"].document.createEvent('CustomEvent'); // MUST be 'CustomEvent'

    this.onMouseOverEvent.initCustomEvent('on_mouse_over', false, false, null);

    if (_index["default"].isMobile()) {
      try {
        _react["default"].initializeTouchEvents(true);
      } catch (e) {}
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.changeActiveElementIfNeeded(prevProps);
  };

  _proto.onContextMenu = function onContextMenu(e) {
    if (!_index["default"].isDev()) {
      e.preventDefault(e);
    }
  };

  _proto.getItemAriaRole = function getItemAriaRole() {
    switch (this.props.styleParams.itemClick) {
      case 'expand':
      case 'fullscreen':
        return 'button';

      case 'link':
        return 'link';

      default:
        return '';
    }
  };

  _proto.composeItem = function composeItem() {
    var _this5 = this;

    var _this$props8 = this.props,
        photoId = _this$props8.photoId,
        id = _this$props8.id,
        hash = _this$props8.hash,
        idx = _this$props8.idx;
    var directLink = this.props.directLink;
    var itemClick = this.props.styleParams.itemClick;

    var _ref2 = directLink || {},
        url = _ref2.url,
        target = _ref2.target;

    var isSEO = (0, _viewModeWrapper.isSEOMode)();
    var noFollowForSEO = this.props.noFollowForSEO;
    var shouldUseNofollow = isSEO && noFollowForSEO;
    var shouldUseDirectLink = !!(url && target && itemClick === 'link');
    var seoLinkParams = shouldUseNofollow ? {
      rel: 'nofollow'
    } : {};
    var linkParams = shouldUseDirectLink ? _objectSpread({
      href: url,
      target: target
    }, seoLinkParams) : {};

    var innerDiv = _react["default"].createElement("a", _extends({
      "data-id": photoId,
      "data-idx": idx,
      key: 'item-container-link-' + id
    }, linkParams), _react["default"].createElement("div", {
      className: this.getItemContainerClass(),
      onContextMenu: function onContextMenu(e) {
        return _this5.onContextMenu(e);
      },
      id: _cssScrollHelper.cssScrollHelper.getDomId(this.props),
      ref: function ref(e) {
        return _this5.itemContainer = e;
      },
      onMouseOver: this.onMouseOver,
      onMouseOut: function onMouseOut() {
        _this5.props.actions.eventsListener(_events["default"].HOVER_SET, -1);
      },
      onClick: this.onItemClick,
      onKeyDown: this.onKeyPress,
      tabIndex: this.getItemContainerTabIndex(),
      "aria-label": this.getItemAriaLabel(),
      "data-hash": hash,
      "data-id": photoId,
      "data-idx": idx //aria-label={this.getItemAriaLabel()}
      ,
      role: this.getItemAriaRole(),
      "data-hook": "item-container",
      key: 'item-container-' + id,
      style: this.getItemContainerStyles()
    }, this.getTopInfoElementIfNeeded(), _react["default"].createElement("div", {
      style: this.props.styleParams.isSlideshow ? {} : (0, _itemViewStyleProvider.getImageStyle)(this.props.styleParams)
    }, _react["default"].createElement("div", {
      "data-hook": "item-wrapper",
      className: this.getItemWrapperClass(),
      key: 'item-wrapper-' + id,
      style: this.getItemWrapperStyles()
    }, this.getItemInner())), this.getBottomInfoElementIfNeeded()));

    return innerDiv;
  } //-----------------------------------------| RENDER |--------------------------------------------//
  ;

  _proto.render = function render() {
    return this.composeItem();
  };

  return ItemView;
}(_galleryComponent.GalleryComponent);

var _default = ItemView;
exports["default"] = _default;